export enum VoiceId {
  'GOALMATE' = 'atlas', // Legacy alias — xAI voice
  'GOALMATE_V2' = 'atlas', // xAI voice for program-day TTS
}
